import {
  FormControlLabel,
  type FormControlLabelProps,
  FormHelperText,
  FormLabel,
  Switch,
  type SwitchProps,
} from '@mui/material';
import type { FieldProps } from 'formik';
import { Field } from 'formik';
import React from 'react';

interface FormikToggleFieldProps {
  name: string;
  onChange?: (value: boolean) => void;
  label?: React.ReactNode;
  toggleProps?: SwitchProps;
  headerLabel?: string;
  formProps?: Omit<FormControlLabelProps, 'control' | 'label'>;
}
function FormikToggleField({
  headerLabel,
  label,
  name,
  onChange,
  toggleProps,
  formProps,
}: FormikToggleFieldProps) {
  return (
    <Field name={name} type="checkbox">
      {({ field, meta, form: { handleChange } }: FieldProps<boolean>) => (
        <>
          {headerLabel && (
            <FormLabel
              component="legend"
              sx={({ palette: { primary } }) => ({
                color: primary.main,
              })}
            >
              {headerLabel}
            </FormLabel>
          )}
          <FormControlLabel
            control={
              <Switch
                checked={field.value}
                onChange={(e) => {
                  handleChange(e);
                  onChange?.(e.target.checked);
                }}
                {...toggleProps}
              />
            }
            label={label}
            {...formProps}
          />
          {meta.error ? <FormHelperText>{meta.error}</FormHelperText> : null}
        </>
      )}
    </Field>
  );
}

export default FormikToggleField;
